import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import LoanDrilldownTabPanel from "../LoanDrilldownTabPanel";

import LoanDrilldownTermsSheetHhbCard from "./LoanDrilldownTermsSheetHhbCard";

const LoanDrilldownTermsSheetHhbTab = ({ value, tab }) => {
  const loanDrilldown = useSelector((state) => state?.loanDrilldown);
  const [rowData, setRowData] = useState(null);

  const [quickFilter, setQuickFilter] = useState(null);

  useEffect(() => {
    // if (isNil(rowData)) {
    //   getAllSizerUploadsByDealId({
    //     // data: { loanId: loanDrilldown?._id },
    //     dealId: loanDrilldown?._id,
    //     onSuccessFn: (data) => {
    //       setRowData(data);
    //     },
    //     onFailFn: () => {
    //       getAllSizerUploads({
    //         onSuccessFn: (data) => {
    //           setRowData(data);
    //         },
    //         onFailFn: (error) => {
    //           console.error("Error fetching sizer uploads:", error);
    //         },
    //       });
    //       // console.error("Error fetching sizer uploads:", error);
    //     },
    //   });
    // }
  }, []);

  return (
    <LoanDrilldownTabPanel value={value} tab={tab}>
      <LoanDrilldownTermsSheetHhbCard />
      {/* <ScreenContent>
        {isNil(rowData) ? (
          <LoadingFallback />
        ) : (
          <LoanLetterOfIntentCard />
        )}
      </ScreenContent> */}
    </LoanDrilldownTabPanel>
  );
};

export default LoanDrilldownTermsSheetHhbTab;
